import styled, { keyframes } from 'styled-components';
import { theme } from '../theme';

// Animation keyframes
const modalSlideIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.95) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
`;

// Modal overlay
export const SessionModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

// Modal content
export const SessionModalContent = styled.div`
  background: white;
  border-radius: ${theme.borderRadius.lg};
  max-width: 800px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  animation: ${modalSlideIn} 0.3s ease-out;
`;

// Modal close button
export const SessionModalCloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  font-size: 24px;
  color: #6b7280;
  cursor: pointer;
  padding: 8px;
  border-radius: ${theme.borderRadius.sm};
  transition: all ${theme.transitions.normal};
  z-index: 10;

  &:hover {
    background-color: #f3f4f6;
    color: #374151;
  }
`;

// Modal title
export const SessionModalTitle = styled.h2`
  margin: 0 0 20px 0;
  color: ${theme.colors.text.primary};
  font-size: 24px;
  font-weight: 600;
  padding: 20px 20px 0 20px;
`;

// Dark mode support
export const DarkModeModalContent = styled.div`
  @media (prefers-color-scheme: dark) {
    background: #1f2937;
  }
`;

export const DarkModeModalTitle = styled.h2`
  @media (prefers-color-scheme: dark) {
    color: #f9fafb;
  }
`;
